import { create } from 'zustand';

type SiestaPrep = {
  notificationId: string;
  clientId: string;
  anchor: string;
};

type State = {
  prep: SiestaPrep | null;
  requestPrep: (prep: SiestaPrep) => void;
  consumePrep: () => void;
};

// A notification card requests a prep and navigates to the client; SiestaProvider fires it once
// that client's chat scope has settled. Deliberately not a URL param: a prep is a one-shot send,
// not a location, so it must not survive a reload or a back navigation.
export const useSiestaPrepStore = create<State>()(set => ({
  prep: null,
  requestPrep: prep => set({ prep }),
  consumePrep: () => set({ prep: null }),
}));
